var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M79.502 40.747l-2.714-1.277c.657-2.489 2.647-9.672 2.74-10.003 0-.008.004-.015.006-.025a2.79 2.79 0 00-.654-2.64 2.847 2.847 0 00-2.593-.821l-8.703 1.791-.943-3.298a2.77 2.77 0 00-2.034-1.948 2.813 2.813 0 00-2.706.84l-4.894 5.413c1.042-5.602 2.593-13.848 2.593-13.848a2.801 2.801 0 00-1.09-2.762 2.83 2.83 0 00-2.932-.225l-4.34 2.262c-1.07-1.978-3.61-6.725-4.926-9.19a34.369 34.369 0 00-.848-1.534l.02-.01a2.78 2.78 0 00-4.906-.005l-5.744 10.721a177.187 177.187 0 01-4.213-2.21c-.015-.006-.03-.016-.05-.024a2.818 2.818 0 00-2.967.19 2.802 2.802 0 00-1.1 2.76l2.572 13.92-4.91-5.438a2.787 2.787 0 00-2.69-.849 2.788 2.788 0 00-2.045 1.929l-.973 3.3c-2.656-.578-8.644-1.863-8.66-1.866a2.805 2.805 0 00-2.589.812 2.786 2.786 0 00-.663 2.644l2.75 10.1c-.868.43-1.98.969-2.712 1.321A2.773 2.773 0 005.02 42.96a2.766 2.766 0 001.004 2.481l16.614 13.594a1.824 1.824 0 01-.072.35l-1.192 4.104a2.786 2.786 0 002.999 3.54l13.294-1.593c-.408 3.756-1.368 11.293-1.917 15.5-.003.046-.01.089-.011.136A2.789 2.789 0 0038.519 84h9.029c.756 0 1.488-.313 2.021-.87.524-.55.799-1.303.748-2.162L48.522 65.42c2.223.27 6.32.786 12.244 1.537l.933.119c.075.008.144.015.23.017a2.627 2.627 0 002.203-.9c.457-.524.708-1.19.708-1.88 0-.401-.086-.8-.253-1.162l-1.156-4.012a1.401 1.401 0 01-.035-.093 1.37 1.37 0 01.124-.106c1.171-.908 6.52-5.276 15.901-12.98l.657-.54a2.772 2.772 0 00.999-2.49 2.771 2.771 0 00-1.575-2.182"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/fall.6412be7d.svg";
export { ForwardRef as ReactComponent };